"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gtmRecorder = gtmRecorder;

var _tracking = require("@vpr/tracking");

/**
 * Adds performance timing data to the GTM dataLayer. Relies on GoogleTagManager initilization.
 */
function gtmRecorder(category, label, variable, time) {
  try {
    _tracking.GoogleTagManager.addData({
      event: 'performance_timing',
      // The GTM event type
      'performance_timing.category': category,
      'performance_timing.variable': variable,
      'performance_timing.time': time,
      'performance_timing.label': label
    });
  } catch (e) {
    console.error('GoogleTagManager must be initialized to use the gtmRecorder in LoadTimingTracker.');
  }
}